import React from "react";
import "./style.scss";
import { Col, Row } from "antd";
import { starIcon } from "../../utils/constants";
import { AboutContent } from "../../pagesContent/aboutContent";

export default function About() {
  return (
    <div className="about" id="aboutSection">
      <Row align={"stretch"}>
        <Col xs={24} sm={24} lg={12}>
          <div className="aboutRightside">
            <div className="aboutRightsideContent">
              {starIcon}

              {/* {AboutContent.text.map((block, idx) => {
                if (block.type === "highlight") {
                  return (
                    <p key={idx} className="aboutHighlight">
                      <strong>{block.value}</strong>
                    </p>
                  );
                }

                return (
                  <p key={idx}>
                    {block.parts.map((p, i) =>
                      typeof p === "string" ? (
                        <React.Fragment key={i}>{p}</React.Fragment>
                      ) : p.strong ? (
                        <strong key={i}>{p.value}</strong>
                      ) : (
                        <React.Fragment key={i}>{p.value}</React.Fragment>
                      )
                    )}
                  </p>
                );
              })} */}
              <h1>{AboutContent.heading}</h1>
              <div className="aboutTagline">{AboutContent.tagline}</div>
              <p>{AboutContent.text}</p>

            </div>
          </div>
        </Col>

        <Col xs={24} sm={24} lg={12}>
          <div className="aboutImage">
            <img src={AboutContent.sideImage} alt="" />
          </div>
        </Col>
      </Row>
    </div>
  );
}
